import script from "./CostCategoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./CostCategoryView.vue?vue&type=script&setup=true&lang=js"

import "./CostCategoryView.vue?vue&type=style&index=0&id=8aaa7990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aaa7990"]])

export default __exports__